import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import { Edit, Delete, ArrowDropDown } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch, useSelector } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../reusable/Operations';
import { fomateDate } from '../../utils/fomateDate';
import { deletemultiplesubCategoriesThunk, deletesubCategoriesThunk, seteditSubCategory, setSelectAllsubCat, setSelectedsubIds } from '../../redux/subcategories/getAllSubcategorySlice';
import { deletemultipleCategoriesThunk } from '../../redux/category/getAllCategorySlice';
import { MultipleDeletes } from '../../Svg';
// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '6px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const InactiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#ffc9c9',
  color: '#d9534f',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#d4edda',
  color: '#28a745',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));




const SubcategoriesTable = ({ subcategory, start, end, setPage, page, itemsPerPage, totalItems, handleOpenMenu }) => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bulkDelete, setBulkDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null)

  const { selectedIds, selectAll } = useSelector((state) => state.subcategory);


  const deletesubCategory = (password) => {
    if (bulkDelete) {
      dispatch(deletemultiplesubCategoriesThunk({ ids: selectedIds, password }))
      setBulkDelete(false)
    } else {
      dispatch(deletesubCategoriesThunk({ id: selectedId, password }))
    }
    setIsModalOpen(false);

  }


  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };

  const handleEditClick = (subcategory) => {
    dispatch(seteditSubCategory(subcategory));
    navigate('/master/editSubCategory')
  };


  const handleSelect = (id) => {
    const isExist = selectedIds.includes(id)
    if (isExist) {
      const filter = selectedIds?.filter(i => i !== id)
      return dispatch(setSelectedsubIds(filter))
    }
    const data = [...selectedIds, id]
    dispatch(setSelectedsubIds(data))
  }


  const handleSelectAll = () => {
    if (!selectAll) {
      const ids = subcategory?.map(i => i?._id)
      dispatch(setSelectedsubIds(ids))
      return dispatch(setSelectAllsubCat(true))
    }
    dispatch(setSelectedsubIds([]))
    dispatch(setSelectAllsubCat(false))
  }

  // Bulk delete asks for the Super Admin password in the same box first
  const handleMultipledelete = () => {
    setBulkDelete(true)
    setIsModalOpen(true)
  }



  return (
    <>
      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>

              <HeaderCell>
                <IconButton>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </IconButton>
                Subcategory
                <IconButton onClick={(e) => handleOpenMenu('name')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell sx={{ paddingLeft: '10px' }}>
                Category
                <IconButton onClick={(e) => handleOpenMenu('category')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu('thumbnail.status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Added
                <IconButton onClick={(e) => handleOpenMenu('createdAt')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
                {selectedIds?.length > 0 &&
                  <IconButton onClick={handleMultipledelete}>
                    <MultipleDeletes />
                  </IconButton>
                }
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {subcategory.map((row) => (
              <TableRow key={row._id}>


                <TableCells sx={{
                  width: '25%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* <div>
                      {
                        row?.thumbnail?.photo ? <img src={row?.thumbnail?.photo} style={{ width: 44, height: 44, borderRadius: 2 }} /> : <img src="/assets/profile.png" />
                      }
                    </div> */}
                    <div>
                      <input
                        type="checkbox"
                        checked={selectedIds.find(i => i == row?._id)}
                        onChange={() => handleSelect(row?._id)}
                      />
                    </div>
                    <div style={{
                      maxWidth: "80%",
                       whiteSpace: 'normal',
                      wordWrap: 'break-word'
                    }}>
                      <strong style={{ color: '#1D1F2C' }}>{row.name}</strong>
                      <div style={{ fontSize: '14px', color: '#667085', fontWeight: '500', }}>
                        {row.description}
                      </div>
                    </div>
                  </div>
                </TableCells>

                <ProductText sx={{ width: '25%', color: "#667085", }}>
                  <div style={{ maxWidth: "80%",
                       whiteSpace: 'normal',
                      wordWrap: 'break-word' }}>
                    {row?.category?.name}
                  </div>
                </ProductText>

                <TableCells sx={{ width: '13%' }}>
                  {row?.thumbnail?.status === "ACTIVE" ? (
                    <ActiveChip label="Active" size="small" />
                  ) : (
                    <InactiveChip label="Inactive" size="small" />
                  )}
                </TableCells>

                <TableCells sx={{ width: '13%', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row.createdAt)}
                </TableCells>

                <Operations
                  TableCells={TableCells}
                  viewClick={() => navigate(`/master/viewSubcategory/${row?._id}`)}
                  editClick={() => handleEditClick(row)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'Subcategory'}
                  onClose={() => { setIsModalOpen(false); setBulkDelete(false) }}
                  onDelete={deletesubCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <div>
            <CatPagination
              start={start}
              end={end}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              setPage={setPage}
              page={page}
            />
          </div>
        </div>
      </TableContainerStyled>

    </>
  );
};

export default SubcategoriesTable;
